/*
Code for the Faculty Page
*/

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Footer } from "./Footer";
import edholm from "./images/christina-edholm.jpg";
import ou from "./images/winston-ou.jpg";
import spezio from "./images/michael-spezio.jpg";
import background from "./images/keck.jpg";
import { Header } from "./Header";

export const Faculty = () => {
  return (
    <div>
      <Header />
      <div className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption">Faculty</h1>
        <p className="header-img-text"> Meet our Data Science Professors</p>
      </div>
      <div className="space1" />
      <div className="space2" />
      <Container>
        <Row>
          <Col>
            <img
              className="prof_image"
              src={edholm}
              alt="Christina Edholm"
              style={{ borderRadius: "8px" }}
            />
            <h2 className="faculty-name">
              <a
                href="https://www.scrippscollege.edu/offices/profile/christina-edholm"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Christina Edholm
              </a>
            </h2>
            <p className="faculty_text">Faculty</p>
            <div className="space1" />
            <p style={{ color: "green" }}>
              <strong style={{ color: "black" }}>Department:</strong>{" "}
              Mathematics
            </p>
            <p>
              <strong>Specialty:</strong> Epidemiological modeling and invasive
              species control
            </p>
            <p>
              <strong>Inquiries:</strong> Ask Prof. Edholm about data science
              applications to math research and general questions about the
              minor. Do not ask her about what classes count.
            </p>
            <p>
              <strong>Email: </strong>
              <a
                href="mailto:cedholm@scrippscollege.edu"
                className="faculty-link"
              >
                cedholm@scrippscollege.edu
              </a>
            </p>
            <p>
              <strong>Office: </strong>Miller 1**. Miller is the eastern wing of
              the Humanities Auditorium.
            </p>
            <p>
              <a
                href="https://www.scrippscollege.edu/offices/profile/christina-edholm"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Link to research
              </a>
            </p>
          </Col>
          <Col>
            <img
              className="prof_image"
              src={ou}
              alt="Winston Ou"
              style={{ borderRadius: "8px" }}
            />
            <h2 className="faculty-name">
              <a
                href="https://www.scrippscollege.edu/offices/profile/winston-ou"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Winston Ou
              </a>
            </h2>
            <p className="faculty_text">Co-Director </p>
            <div className="space1" />
            <p style={{ color: "green" }}>
              <strong style={{ color: "black" }}>Department:</strong>{" "}
              Mathematics
            </p>
            <p>
              <strong>Specialty:</strong> Harmonic analysis, mathematical
              imaging
            </p>
            <p>
              <strong>Inquiries:</strong> Ask Prof. Ou about what classes count
              for DS and general questions about the minor.
            </p>
            <p>
              <strong>Email: </strong>
              <a
                href="mailto:wcwou@scrippscollege.edu"
                className="faculty-link"
              >
                wcwou@scrippscollege.edu
              </a>
            </p>
            <p>
              <strong>Office: </strong>Miller 2**. Miller is the eastern wing of
              the Humanities Auditorium.
            </p>
            <p>
              <a
                href="https://www.scrippscollege.edu/offices/profile/winston-ou"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Link to research
              </a>
            </p>
          </Col>
          <Col>
            <img
              className="prof_image"
              src={spezio}
              alt="Michael Spezio"
              style={{ borderRadius: "8px" }}
            />
            <h2 className="faculty-name">
              <a
                href="https://www.scrippscollege.edu/offices/profile/michael-spezio"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Michael Spezio
              </a>
            </h2>
            <p className="faculty_text">Co-Director</p>
            <div className="space1" />
            <p style={{ color: "green" }}>
              <strong style={{ color: "black" }}>Department:</strong> Psychology
            </p>
            <p>
              <strong>Specialty:</strong> Computational cognitive neuroscientist
              focusing on valuation, emotion, and decision making in interaction
            </p>
            <p>
              <strong>Inquiries:</strong> Ask Prof. Spezio about what classes
              count for DS and general questions about the minor.
            </p>
            <p>
              <strong>Email: </strong>{" "}
              <a
                href="mailto:mspezio@scrippscollege.edu"
                className="faculty-link"
              >
                mspezio@scrippscollege.edu
              </a>
            </p>
            <p>
              <strong>Office: </strong>On research leave.
            </p>
            <p>
              <a
                href="https://www.scrippscollege.edu/offices/profile/michael-spezio"
                target="_blank"
                rel="noreferrer"
                className="faculty-link"
              >
                Link to research
              </a>
            </p>
          </Col>
        </Row>
      </Container>
      <div className="space1" />
      <Footer />
    </div>
  );
};
